/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface OrgVacancyControllerUpdateByIdRequest { 
    positionName?: string;
    companyId?: string;
    departmentId?: string | null;
    jobPositionId?: string | null;
    notes?: string | null;
    bossUserId?: number | null;
    peerUserIds?: Array<number>;
    collaboratorUserIds?: Array<number>;
}

